import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const traineeRoute: RouteConfig<'with-page'> = {
    name: 'Trainee',
    path: '/training/trainees/:id',
    page: lazy(() => import('.')),
    flags: ['member-route', 'no-menu-item'],
    context:'member'
}